import { useWifiStrength } from './useWifiSignalMeter';

export default function WifiIndicator() {
  const { strength, speedMbps } = useWifiStrength();

  return (
    <div style={{ display: 'flex', gap: '8px' }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span className="material-icons">arrow_downward</span>
        {speedMbps + 'Mbps'}
      </div>
      {/* <div style={{ display: 'flex', alignItems: 'center' }}>
        <span className="material-icons">arrow_upward</span>
        {speedMbps + 'Mbps'}
      </div> */}
      <span className="material-icons">network_wifi_{strength}_bar</span>
    </div>
  );
}
